/*
 * Microsoft Clarity click events, auto-derived — no per-section wiring.
 *
 * Event name format: <action>:<section>[:<label>]
 *   action  — slider_next | slider_prev | slider_dot | slide_click | click
 *   section — slug of the closest data-clarity-section attribute (sections
 *             stamp it from their "Analytics name" or title setting, so the
 *             name is readable without repo access, e.g. "best-selling");
 *             falls back to the section id suffix from the enclosing
 *             shopify-section wrapper (e.g. "hero_swiper_TUKBEJ", "header")
 *   label   — for links: "product", collection handle, or path slug;
 *             otherwise slugified aria-label / text content
 *
 * Per-element override: data-clarity-event="my-event-name" (on the element or
 * any ancestor) wins over derivation. Optional data-clarity-label overrides
 * just the label part.
 *
 * Clarity is injected by the Microsoft Clarity Shopify app embed; this script
 * only calls window.clarity when it exists and must never break the page.
 */
(function () {
  'use strict';

  if (window.__ifbClarityEvents) return;
  window.__ifbClarityEvents = true;

  var SELECTOR = [
    '[data-clarity-event]',
    '.swiper-button-next',
    '.swiper-button-prev',
    '.swiper-pagination-bullet',
    'a[href]',
    'button',
    '[role="button"]',
    'input[type="submit"]',
  ].join(',');

  function track(name) {
    if (!name) return;
    try {
      if (typeof window.clarity === 'function') {
        window.clarity('event', String(name).slice(0, 254));
      }
    } catch (err) {
      /* analytics must never break the storefront */
    }
  }

  function slugify(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .trim()
      .slice(0, 64)
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 40);
  }

  function sectionOf(el) {
    var named = el.closest('[data-clarity-section]');
    if (named) {
      var name = slugify(named.getAttribute('data-clarity-section'));
      if (name) return name;
    }
    var section = el.closest('[id^="shopify-section-"]');
    if (!section || !section.id) return '';
    var id = section.id;
    var sep = id.lastIndexOf('__');
    return sep !== -1 ? id.slice(sep + 2) : id.replace(/^shopify-section-/, '');
  }

  function actionOf(el) {
    var cl = el.classList;
    if (cl.contains('swiper-button-next')) return 'slider_next';
    if (cl.contains('swiper-button-prev')) return 'slider_prev';
    if (cl.contains('swiper-pagination-bullet')) return 'slider_dot';
    if (el.closest('.swiper-slide, .jdgm-carousel-item')) return 'slide_click';
    return 'click';
  }

  // Keeps event-name cardinality bounded: individual products collapse to
  // "product" (the recording shows which one), collections keep their handle.
  function linkLabel(el) {
    var href = el.getAttribute('href') || '';
    if (!href || href.charAt(0) === '#') return '';
    var url;
    try {
      url = new URL(href, window.location.origin);
    } catch (err) {
      return '';
    }
    if (url.host !== window.location.host) return slugify(url.host);
    var path = url.pathname;
    if (/\/products\//.test(path)) return 'product';
    var collection = path.match(/\/collections\/([^/]+)/);
    if (collection) return slugify(collection[1]);
    if (path === '/' || path === '') return 'home';
    return slugify(path.replace(/^\/+|\/+$/g, '').replace(/\//g, '-'));
  }

  function labelOf(el) {
    var explicit = el.getAttribute('data-clarity-label');
    if (explicit) return slugify(explicit);
    if (el.tagName === 'A') {
      var fromHref = linkLabel(el);
      if (fromHref) return fromHref;
    }
    return slugify(el.getAttribute('aria-label') || el.textContent || el.value || '');
  }

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target || typeof target.closest !== 'function') return;
      var el = target.closest(SELECTOR);
      if (!el) return;

      var override = el.closest('[data-clarity-event]');
      if (override) {
        track(override.getAttribute('data-clarity-event'));
        return;
      }

      var action = actionOf(el);
      var parts = [action];
      var section = sectionOf(el);
      if (section) parts.push(section);
      if (action === 'slide_click' || action === 'click') {
        var label = labelOf(el);
        if (label) parts.push(label);
      }
      track(parts.join(':'));
    },
    true
  );
})();
